export const MEDIA = {
  logo: "/logo.png",
  // Real portrait of Ffyona (colour, smiling) from original website
  portrait: "/room.jpg",
  // Black & white therapy-room photo from original website
  interior: "/ffyona-portrait.jpg",
  mncps: "/mncps-acc.jpg",
  // Calming hero imagery (client-provided)
  hero: "/hero-beach.webp",
  nature:
    "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};
